import type { PlayerState } from './types';

export const API_BASE = '/api';

export const EMPTY_PLAYER: PlayerState = {
  nowPlaying: null,
  paused: false,
  volume: 100,
  loopMode: 'off',
  autoplay: false,
  positionMs: 0
};

export function sourceLabel(value?: string | null) {
  if (!value) return 'Unknown';
  const source = value.toLowerCase();
  if (source.includes('youtube')) return 'YouTube';
  if (source.includes('soundcloud')) return 'SoundCloud';
  if (source.includes('spotify')) return 'Spotify';
  return value;
}

export function formatTime(ms: number) {
  const sec = Math.max(0, Math.floor((ms || 0) / 1000));
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function positionWidth(positionMs: number) {
  const max = 240_000;
  return `${Math.min(100, (positionMs / max) * 100)}%`;
}
